<template>
  <div class="Footer">
    <footer class="fixed-bottom border-top p-2" :class="{ 'm-select-company': empresaSeleccionada }">
      <div class="container">
        <div class="d-flex" :class="{ 'justify-content-around': !idUsuario, 'justify-content-between': idUsuario }">
          <a v-if="idUsuario" href="javascript:void(0)" type="button" data-bs-toggle="offcanvas"
            data-bs-target="#empresasOffcanvas" aria-controls="empresasOffcanvas" aria-expanded="false"
            aria-label="Abrir Empresas">
            <label class="icon business">
              <ion-icon name="business"></ion-icon>
            </label>
          </a>
          <a href="https://wa.me/573105608414?text=Necesito%20Soporte%20Técnico%20con%20GoodBzz" target="_blank">
            <label class="icon logo-whatsapp">
              <ion-icon name="logo-whatsapp"></ion-icon>
            </label>
          </a>
          <a v-if="idUsuario">
            <label class="icon notifications">
              <ion-icon name="notifications"></ion-icon>
            </label>
          </a>
        </div>
        <!-- OFFCANVAS - EMPRESAS -->
        <div class="offcanvas offcanvas-bottom border-bottom" tabindex="-1" id="empresasOffcanvas"
          aria-labelledby="empresasOffcanvasLabel">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title fw-bold" id="empresasOffcanvasLabel">Empresas</h5>
          </div>
          <div class="offcanvas-body justify-content-start mb-3">
            <Empresas />
          </div>
        </div>
      </div>
    </footer>
    <!--<div class="card-footer text-muted text-center footer">
      <div class="collapse color__Transparente" id="navMovil">
      <MenuMovil />
    </div>
    <div class="collapse" v-if="$store.state.usuario.correoVerificado === true" id="empresas">
      <Empresas />
    </div>
    <div class="collapse" v-if="$store.state.usuario.correoVerificado === true" id="notificaciones">
      <Notificaciones />
    </div>
    <div class="bottom-nav bg__ColorBase">
      <template v-if="$store.state.usuario.correoVerificado === true">
        <div class="puntero" data-toggle="collapse" data-target="#empresas" aria-expanded="false"
          aria-controls="collapseExample">
          <label class="icon business" v-tooltip="{
              content: textoEmpresas,
              html: true,
            }">
            <ion-icon name="business-outline"></ion-icon>
            <ion-icon class="fill" name="business"></ion-icon>
          </label>
        </div>
      </template>
<input type="radio" name="radio" value="2" id="tab-2"
  onclick="window.open('https://wa.me/573105608414?text=Necesito%20Soporte%20Técnico%20con%20GoodBzz.','_blank')" />
<label class="icon logo-whatsapp" v-tooltip="{
          content: textoWhatsApp,
          html: true,
        }" for="tab-2">
  <ion-icon name="logo-whatsapp"> </ion-icon>
  <ion-icon class="fill" name="logo-whatsapp"></ion-icon>
</label>
<input type="radio" name="radio" value="3" id="tab-3" @click="agendarLlamada()" />
<label class="icon call" v-tooltip="{
          content: textoAgendar,
          html: true,
        }" for="tab-3">
  <ion-icon name="call-outline"></ion-icon>
  <ion-icon class="fill" name="call"></ion-icon>
</label>

<template v-if="$store.state.usuario.correoVerificado === true">
        <input type="radio" name="radio" value="4" id="tab-4" :checked="$route.path == '/asesorias'"
          @click="irAsesorias()" />
        <label class="icon document" v-tooltip="{
            content: textoAsesor,
            html: true,
          }" for="tab-4">
          <ion-icon name="document-text-outline"></ion-icon>
          <ion-icon class="fill" name="document"></ion-icon>
        </label>
      </template>

<template v-if="$store.state.usuario.correoVerificado === true">
        <div class="puntero" data-toggle="collapse" data-target="#notificaciones" aria-expanded="false"
          aria-controls="collapseExample">
          <label class="icon star" v-tooltip="{
              content: textoNotificaciones,
              html: true,
            }">
            <ion-icon name="star-outline"></ion-icon>
            <ion-icon class="fill" name="star"></ion-icon>
            <i v-if="numeroNotificaciones === 0"></i>
            <sup>
              <span class="badge badge-danger p-1 ml-1 numero__Notificaciones">
                {{ numeroNotificaciones }}
              </span>
            </sup>
          </label>
        </div>
      </template>
</div>-->
  </div>
</template>

<script>
import { auth } from "@/firebase";
import Empresas from "./Empresas/Empresas.vue";
//import { collection, doc, setDoc, serverTimestamp, query, onSnapshot, where } from "firebase/firestore";
//import Swal from "sweetalert2";
export default {
  name: "Footer",

  components: {
    Empresas
  },

  props: {
    empresaSeleccionada: Boolean
  },

  data() {
    return {
      id: "",
      /*todayDate: new Date().toISOString().slice(0, 10),
      numeroNotificaciones: 0,
      textoEmpresas: "<b>Empresa(s)</b>",
      textoWhatsApp: "<b>Soporte Técnico</b>",
      textoAgendar: "<b>Agendar llamada</b>",
      textoAsesor: "<b>Asesorías</b>",
      textoNotificaciones: "<b>Notificaciones</b>",*/
      idUsuario: ""
    };
  },

  async created() {
    let usuario = auth.currentUser;
    if (usuario) {
      let usuarioDB = await this.$store.state.obtenerUsuario(usuario.uid);
      if (usuarioDB) {
        this.idUsuario = usuarioDB.id
        //await this.obtenerNotificaciones(usuario.uid);
      }
    }
  },

  methods: {
    /*async obtenerNotificaciones(id) {
      const q = query(collection(db, "notificaciones"), where("idUsuario", "==", id), where("esLeida", "==", false));
      onSnapshot(q, (snapshot) => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === "added") {
            this.numeroNotificaciones++;
          } else if (change.type === 'modified') {
          } else if (change.type === "removed") {
            this.numeroNotificaciones--;
          }
        });
      });
    },

    async agendarLlamada() {
      const refAgenda = doc(collection(db, "agendar"));
      this.id = refAgenda.id;
      Swal.fire({
        heightAuto: false,
        title: "Agenda tu llamada",
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
        html: `
        <div class="card" style="box-shadow: none;">
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <center>
                  <div class="form-group">
                    <b>Bienvenido (a)</b><br><br>
                    <p style="text-align: justify;">Nuestro horario de atención es de <b>7:00 am</b> a <b>12:00 pm</b> y de <b>2:00 pm</b> a <b>6:00 pm</b> de lunes a viernes - sábados de <b>9:00 am</b> a <b>12:00 pm</b>.</p>
                  </div>
                  <div class="form-group mt-4">
                    <input type="text" id="nombre" class="form-control" placeholder="Nombre y Apellido">
                  </div>
                  <div class="form-group">
                    <input type="email" id="correo" class="form-control" placeholder="Correo Electrónico">
                  </div>
                  <div class="form-group">
                    <input type="tel" id="telefono" class="form-control" placeholder="Teléfono">
                  </div>
                  <div class="form-group mt-5">
                    <b>¿A qué hora te llamamos?</b><br><br>
                    <b>Fecha</b><br>
                    <input type="date" id="fecha" class="form-control" min="${this.todayDate}"><br>
                  </div>
                  <div class="form-group">
                  <b>Hora</b><br>
                    <input type="time" id="hora" class="form-control">
                  </div>
                  <div class="form-group mt-5">
                    <div class="row">
                      <div class="col-md-1 form-group">
                        <div class="form-check">
                          <label
                            class="form-check-label"
                            style="font-size: 14pt; color: black"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              id="terminos"
                              checked
                            />
                            <span class="form-check-sign">
                              <span class="check"></span>
                            </span>
                          </label>
                        </div>
                      </div>
                      <div class="col-md-11">
                        <label style="text-align: justify;">
                          Acepto los <b>términos</b>, <b>condiciones</b>, <b>tratamiento de datos y tratamiento de datos sensibles</b>. (Ley 1581 de 2012, Decreto 1377 de 2013 y demás normas de acuerdo a la región)
                        </label>
                      </div>
                    </div>
                  </div>
                </center>
              </div>
            </div>
          </div>
        </div>
        `,
        background: "rgb(255, 245, 231)",
        confirmButtonText: "Agendar",
        confirmButtonColor: "#3c3c44",
        focusConfirm: false,
        showCloseButton: true,
        preConfirm: () => {
          if (Swal.getPopup().querySelector("#nombre").value == "" ||
            Swal.getPopup().querySelector("#correo").value == "" ||
            Swal.getPopup().querySelector("#telefono").value == "" ||
            Swal.getPopup().querySelector("#fecha").value == "" ||
            Swal.getPopup().querySelector("#hora").value == "") {
            Swal.showValidationMessage("Diligencie los campos requeridos.");
          }
          else {
            const formulario = {
              id: this.id,
              nombre: Swal.getPopup().querySelector("#nombre").value,
              correo: Swal.getPopup().querySelector("#correo").value,
              telefono: Swal.getPopup().querySelector("#telefono").value,
              fecha: Swal.getPopup().querySelector("#fecha").value,
              hora: Swal.getPopup().querySelector("#hora").value,
              terminos: true,
              registro: {
                creacion: serverTimestamp(),
                actualizacion: serverTimestamp(),
              },
            };
            return formulario;
          }
        },
      }).then((result) => {
        if (result.value) {
          setDoc(doc(db, "agendar", this.id), result.value);
          this.$store.state.alerta("success", "¡Registro Exitoso!", "Se ha agendado tu llamada.");
        }
        else {
          this.$store.state.alerta("warning", "¡Advertencia!", "No se agendó tu llamada.");
        }
      });
    },

    irAsesorias() {
      this.$router.push("/asesorias");
    },*/
  },
}
</script>

<style>
footer .offcanvas-backdrop {
  height: 80dvh;
  top: 70px !important;
}

footer.m-select-company .offcanvas-backdrop {
  top: 93px !important;
}

@media screen and (max-width: 990px) {
  footer .offcanvas-backdrop {
    top: 65px !important;
  }

  footer.m-select-company .offcanvas-backdrop {
    top: 90px !important;
  }
}
</style>

<style scoped>
/* TEMA CLARO */
footer {
  background: rgb(248, 249, 250) !important;
}

footer a {
  color: #343434;
}

label ion-icon {
  cursor: pointer;
  font-size: 16pt;
}

.offcanvas-bottom {
  height: 490px !important;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  margin-bottom: 40px;
  background: rgb(248, 249, 250) !important;
}

.offcanvas-body {
  overflow-y: hidden;
}

@media screen and (max-width: 990px) {
  .offcanvas {
    border-top-right-radius: 25px;
    border-top-left-radius: 25px;
  }

  .offcanvas-bottom {
    height: 420px !important;
  }
}

/* TEMA OSCURO */
[data-bs-theme="dark"] footer {
  background: rgb(33, 33, 33) !important;
  border: none !important;
}

[data-bs-theme="dark"] footer a {
  color: #fff;
}
</style>